import React from "react";
import { useQuery } from "@tanstack/react-query";
import { AlertTriangle } from "lucide-react";
import { fetchUpstreamStatus } from "@/lib/api";

export const ApiStatusBanner = () => {
  const { data } = useQuery({
    queryKey: ["upstream-status"],
    queryFn: fetchUpstreamStatus,
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  if (!data || data.reachable) return null;

  return (
    <div
      data-testid="api-status-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-amber-500 text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-2 shadow"
    >
      <AlertTriangle className="h-4 w-4" />
      Standard injoignable — nouvelle tentative…
    </div>
  );
};
